// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Xo7YT","focusable":"styles_focusable__hFu2N","image":"styles_image__4gyDo","bonus":"styles_bonus__CuDq7","onMobileBonus":"styles_onMobileBonus__f-290"};